var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReferIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8408 3.71117e-08H1.15821C0.518463 0.000320472 -0.00016018 0.519264 3.71117e-08 1.15917V19.8418C0.000320472 20.4815 0.519264 21.0002 1.15917 21H19.8408C20.4809 21.0002 20.9998 20.4814 21 19.8413C21 19.8411 21 19.841 21 19.8408V1.15821C20.9997 0.518463 20.4807 -0.00016018 19.8408 3.71117e-08Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.847 21V12.8008H17.5111L17.9102 9.5915H14.847V7.54752C14.847 6.62048 15.095 5.98881 16.3763 5.98881H18V3.12617C17.7175 3.08719 16.7483 3 15.6204 3C13.2657 3 11.6541 4.49077 11.6541 7.22966V9.5915H9V12.8008H11.6541V21H14.847Z",
    fill: "#4267B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferIcon1);
export default __webpack_public_path__ + "static/media/refer-icon1.409af1bab3d9a0b2910c86be38a577b4.svg";
export { ForwardRef as ReactComponent };